<template>
  <v-card v-if="entity.relatedEntities && entity.relatedEntities.length">
    <v-card-text>
      <h2><v-icon>group</v-icon>Related clients</h2>
      <div v-for="e in entity.relatedEntities" :key="e.id">
        <EntityZ :entity="e" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "RelatedEntities",
  components: {
    EntityZ
  },
  props: ["entity"]
};
</script>
